import styled from 'styled-components';
import { ICON_DEFAULTS } from './Icon';

const IconIdea = ({ className, width, height, stroke, fill }) => {
  return (
    <SVG
      className={className}
      width={width || ICON_DEFAULTS.WIDTH}
      height={height || ICON_DEFAULTS.HEIGHT}
      viewBox="0 0 14 14"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 12.92C1.00582 12.3455 1.15728 11.7819 1.44022 11.2819C1.73787 10.7616 2.16685 10.3286 2.68428 10.0261C3.20171 9.72357 3.78947 9.56213 4.38884 9.55793C5.59782 9.56069 6.7422 10.2289 7.33746 11.2819C7.62024 11.7816 7.7717 12.3449 7.77768 12.9191M9.64191 1.75677V1M12.2251 2.68611L12.8443 2.25143M7.0569 2.68611L6.43672 2.25143M4.38792 7.95026C4.61663 7.95556 4.84409 7.91509 5.05694 7.83124C5.26979 7.74738 5.46373 7.62182 5.62736 7.46194C5.79099 7.30206 5.92101 7.11108 6.00978 6.90023C6.09855 6.68939 6.14428 6.46292 6.14428 6.23415C6.14428 6.00538 6.09855 5.77891 6.00978 5.56806C5.92101 5.35722 5.79099 5.16624 5.62736 5.00636C5.46373 4.84648 5.26979 4.72092 5.05694 4.63706C4.84409 4.5532 4.61663 4.51274 4.38792 4.51804C3.93967 4.52844 3.51328 4.71381 3.19993 5.03451C2.88658 5.35521 2.71115 5.78578 2.71115 6.23415C2.71115 6.68252 2.88658 7.11309 3.19993 7.43379C3.51328 7.75449 3.93967 7.93986 4.38792 7.95026ZM11.5181 5.14837C11.5166 4.89861 11.4657 4.65162 11.3684 4.42158C11.2711 4.19153 11.1294 3.98297 10.9512 3.80787C10.7731 3.63276 10.5622 3.49456 10.3305 3.4012C10.0989 3.30784 9.85105 3.26116 9.6013 3.26384C9.35164 3.27158 9.10597 3.32857 8.8784 3.43152C8.65083 3.53447 8.44583 3.68136 8.27518 3.86375C8.10454 4.04615 7.9716 4.26046 7.884 4.49437C7.79641 4.72829 7.75589 4.9772 7.76476 5.22682C7.78286 5.56067 7.88839 5.8839 8.07078 6.16412C8.25316 6.44433 8.50599 6.67169 8.80393 6.82341V7.7463C8.8056 7.80057 8.82828 7.85208 8.86719 7.88996C8.9061 7.92783 8.9582 7.94912 9.0125 7.94933H10.2685C10.323 7.94936 10.3753 7.92818 10.4144 7.89028C10.4536 7.85237 10.4764 7.80073 10.478 7.7463V6.8068C10.785 6.65001 11.0439 6.41307 11.2272 6.1211C11.4105 5.82913 11.5104 5.49301 11.5181 5.14837Z"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SVG>
  );
};

const SVG = styled('svg')({
  fill: 'none',
  stroke: 'currentcolor',
});

export { IconIdea };
